import { render, staticRenderFns } from "./ItemPDFImportInterface.vue?vue&type=template&id=08417a08"
import script from "./ItemPDFImportInterface.vue?vue&type=script&lang=js"
export * from "./ItemPDFImportInterface.vue?vue&type=script&lang=js"
import style0 from "./ItemPDFImportInterface.vue?vue&type=style&index=0&id=08417a08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports